import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Search } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { roleServices } from 'src/services/auth/rol/rol.service'
import { clientServices } from 'src/services/auth/client/client.service'

export const SelectClientModal = ({id, open, onClose, refetch}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const [clients, setClients] = useState()
    const [loadingClients, setLoadingClients] = useState()
    const [searchBy, setSearchBy] = useState(null)
    const [businessUnitSelect,setBusinessUnitSelect] = useState()
    const [timeoutClients, setTimeoutClients] = useState()
    const [cloneLoading, setCloneLoading] = useState(false)

    const onSendClone = async () =>{
        setCloneLoading(true)
        await roleServices.sendClone(id, businessUnitSelect).then(()=>{
            notify('ra.notification.clone_item_success',{type:'success', messageArgs:{item:id}})
            onClose()
            refetch()
        }).catch(()=>{
            notify('ra.notification.clone_item_error',{type:'error', messageArgs:{item:id}})
        }).finally(()=>{
            setCloneLoading(false)
        })
    }

    const showKeys = (business_unit) => {
        let string = ''
        const business_name = business_unit?.fiscal_data_relation?.name || business_unit?.fiscal_data_name
        const fantasy_name = business_unit?.fantasy_name
        const long_name = business_unit?.long_name

        if (business_name) {
        string += '(RS) ' + business_name
        }
        if (fantasy_name) {
        string += (business_name ? ' - (NF) ' : '') + fantasy_name
        }
        if (long_name) {
        string += (business_name || fantasy_name ? ' - (NL) ' : '') + long_name
        }

        return string
    }

    const onChangeClient = (value) => {
        clearTimeout(timeoutClients)
        if (value && searchBy) {
          const timeout = setTimeout(async () => {
            setLoadingClients(true)
            let params = {}
            if (isNaN(value)) {
              params[searchBy] = value
            } else {
              params['id'] = value
            }
            try {
              const response = await clientServices.getByAll(params)
              setClients(response)
            } catch (error) {
              setClients([])
            } finally {
              setLoadingClients(false)
            }
          }, 1000)
          setTimeoutClients(timeout)
        } else {
          setClients([])
        }
      }

    const onChangeSelectedClient = (client) => {
        setBusinessUnitSelect(client.id)
    }

    const handleInput = (event) => {
        if (searchBy === 'id') {
        const value = event.target.value
        // sacar caracteres que no sean números
        const numericValue = value.replace(/[^0-9]/g, '')
        if (value !== numericValue) {
            event.target.value = numericValue
            event.preventDefault()
        }
        }
    }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>
            {`${translate('ra.action.select')} ${translate('ra.field.client')}`}
        </DialogTitle>
        <DialogContent>
            <Grid container>
                <EditInputsWrap md={6} lg={6} label={translate('ra.field.search_by')}>
                    <Autocomplete
                        size='small'
                        options={[
                        {
                            id: 'short_name',
                            name: translate('ra.field.short_name'),
                        },
                        {
                            id: 'long_name',
                            name: translate('ra.field.long_name'),
                        },
                        {
                            id: 'id',
                            name: translate('ra.field.id'),
                        },
                        ]}
                        renderInput={(params) => <TextField {...params} label='' />}
                        getOptionLabel={(option) => option.name}
                        noOptionsText={translate('ra.validation.noOptionsText')}
                        placeholder={translate('ra.field.search_by')}
                        onChange={(e, value) => {
                            setSearchBy(value?.id)
                            setClients([])
                        }}
                    />
                    </EditInputsWrap>
                <EditInputsWrap md={6} lg={6} className='input-gray'>
                    <Autocomplete
                        size='small'
                        options={clients || []}
                        getOptionLabel={(option) => showKeys(option)}
                        loading={loadingClients}
                        loadingText={translate('ra.action.loading')}
                        filterOptions={() => clients}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={translate('ra.field.search_client')}
                            onChange={(e) => onChangeClient(e.target.value)}
                            onInput={handleInput}
                            InputProps={{
                            ...params.InputProps,
                            startAdornment: <Search />,
                            endAdornment: (
                                <>
                                {loadingClients ? <CircularProgress color='inherit' size={20} /> : null}
                                {params.InputProps.endAdornment}
                                </>
                            ),
                            }}
                        />
                        )}
                        onChange={(e, value) => onChangeSelectedClient(value)}
                        noOptionsText={translate('ra.validation.noOptionsText')}
                        placeholder={translate('ra.field.search_client')}
                        disabled={!searchBy}
                    />
                    </EditInputsWrap>
                </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} variant='outlined'>
              {translate('ra.action.cancel')}
            </Button>
            <LoadingButton
              loading={cloneLoading}
              loadingPosition='start'
              variant='contained'
              onClick={onSendClone}
              disabled={cloneLoading}
            >
              {translate('ra.action.to_confirm')}
            </LoadingButton>
          </DialogActions>
    </Dialog>
  )
}
